import { render, staticRenderFns } from "./InputInteger.vue?vue&type=template&id=0c485a58&"
import script from "./InputInteger.vue?vue&type=script&lang=js&"
export * from "./InputInteger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports